module.exports = __webpack_public_path__ + "static/img/logo.101dfff1.png";